import { useRouter } from 'next/router'

import { COBRANDING_PARTNER_COOKIE_KEY } from '@/constants'
import Cookies from 'js-cookie'
import { useGetQueryParam } from 'src/hooks/useGetQueryParam'

import { CobrandingNewPartners } from './useGetCobrandingNewPartners'

const audiencePaths = ['/life/quick-online-quote/']

export const useNewForbesCobranding = () => {
  const { asPath } = useRouter()
  const queryUtmParams = useGetQueryParam('utm_term')
  const queryUtmContent = useGetQueryParam('utm_content')

  const pathnameWithoutQuery = asPath.split('?')[0]
  const isValidAudiencePath = audiencePaths.includes(pathnameWithoutQuery)

  const isNewForbesAudience =
    queryUtmParams === '1955282' && queryUtmContent?.includes('_2966875')

  const isEnabled = isValidAudiencePath && isNewForbesAudience

  if (isEnabled) {
    Cookies.set(
      COBRANDING_PARTNER_COOKIE_KEY,
      CobrandingNewPartners.NewForbes,
      {
        expires: 365,
      }
    )
  }

  return isEnabled
}
